export default __webpack_public_path__ + "static/media/gold.e5fef112.png";